import { Application, DisplayObject } from "pixi.js"
import ManaWorld from "../loop/ManaWorld"
import TickingObject, { TickingObjectOptions } from "../modules/TickingObject"

export type ManaWorldPhysicsWrapperOptions = { manaWorld: ManaWorld } & TickingObjectOptions

export default class ManaWorldPhysicsWrapper extends TickingObject<DisplayObject, Application> {

	manaWorld

	constructor({ manaWorld, ...rest }: ManaWorldPhysicsWrapperOptions) {
		super(rest)

		this.manaWorld = manaWorld
	}

	tick(delta: number) {
		this.manaWorld.tick(delta)
	}

	dispose() {
		super.dispose()
		this.manaWorld.dispose()
	}

}